import {
  CircularProgress,
  CssBaseline,
  Typography,
} from "@mui/material";
import { Suspense, lazy } from "react";
import { Navigate, Outlet, RouteObject } from "react-router-dom";
import AppBar from "../components/AppBar";
import Estoque from "../screens/Estoque";
import Tarefas from "../screens/Tarefas";
import FluxoDetalhe from "../screens/Configuracoes/Fluxos/Detalhe";
import Comercial from "../screens/Comercial";
import MIPedidosListarTodos from "../screens/Comercial/components/MIPedidos/ListarTodos";
import Configuracoes from "../screens/Configuracoes";
import Financeiro from "../screens/Financeiro";
import GiroDeEstoque from "../screens/Estoque/components/Relatorios/GiroDeEstoque";
import MIAnaliseCreditoListarTodas from "../screens/Financeiro/components/MIAnaliseDeCredito/ListarTodas";
import ExpedicaoPedidos from "../screens/Estoque/components/ExpedicaoPedidos";
import MIProdutosListarTodas from "../screens/Estoque/components/MIProdutos/LIstarTodas";
import Cafe from "../screens/Cafe";
import PageListaLoteCafe from "../screens/Cafe/components/PageListaLotesCafe";
import MIContasReceberListarTodas from "../screens/Financeiro/components/MIContasReceber/ListarTodas";
import MIContasPagarListarTodas from "../screens/Financeiro/components/MIContasPagar/ListarTodas";
import ConfiguracoesFinanceiro from "../screens/Financeiro/components/MIConfiguracoes";
import MIContasReceberListarRecibos from "../screens/Financeiro/components/MIContasReceber/ListarRecibos";
import MIContaCorrenteConsumoVisaoGeral from "../screens/Financeiro/components/MIContaCorrenteConsumo/VisaoGeral";
import IntegracaoBancaria from "../screens/Financeiro/components/MIIntegracaoBancaria";
import { ModalDetalheProcessoProvider } from "../components/ModalContexts/ModalDetalheProcessoContext";
import Cadastros from "../screens/Cadastros";
import MIPublicosListarTodos from "../screens/Cadastros/components/MIPublicos/ListarTodos";
import MILojasListarTodas from "../screens/Cadastros/components/MILojas/ListarTodas";
import MIProdutosListarTodos from "../screens/Comercial/components/MlProdutos/ListarTodos";
import MIPragasListarTodos from "../screens/ReceituarioAgronomico/components/MIPragas/ListarPragas";
import MIIngredientesAtivosListarTodos from "../screens/ReceituarioAgronomico/components/MIIngredientesAtivos/ListaIngredientesAtivos";
import MIAgrotoxicosListarTodos from "../screens/ReceituarioAgronomico/components/MIAgrotoxicos/ListarTodos";
import ConfiguracoesEstoque from "../screens/Estoque/components/MIConfiguracoes";
import MICaixaBancosExtratoContas from "../screens/Financeiro/components/MICaixaBancos/ExtratoContas";
import MIChequesListarTodos from "../screens/Financeiro/components/MICheques/ListarCheques";
import MIChequesListarTodosDevolvidos from "../screens/Financeiro/components/MICheques/ListarChequesDevolvidos";
import ConfiguracoesComercial from "../screens/Comercial/components/MlConfiguracoes";
import { ModalDetalhePedidoProvider } from "../screens/Comercial/components/ModalDetalhePedidoContext";
import ListarLancamentos from "../screens/Financeiro/components/MICaixaBancos/ListarLancamentos";
import ReceituarioAgronomico from "../screens/ReceituarioAgronomico";
import MIAgronomoListarTodos from "../screens/ReceituarioAgronomico/components/MIAgronomos/ListarTodos"
import MICulturasListarTodos from "../screens/ReceituarioAgronomico/components/MICulturas/ListarCulturas";
import MIPrescricoesListarTodos from "../screens/ReceituarioAgronomico/components/MIPrescricoes/ListarTodos";
import FormulariosDynDetalhe from "../screens/Configuracoes/FormulariosDyn/Detalhe";
import DialogContato from "../components/BasicComponents/Dialogs/DialogContato";
import ResumoOperacoes from "../screens/Comercial/components/MIPedidos/ResumoOperacoes";
import ListarSolicitacoes from "../screens/Estoque/components/MICompras/ListarSolicitacoes";
import ListarOcs from "../screens/Estoque/components/MICompras/ListarOcs";
import MICuponsListarTodos from "../screens/Financeiro/components/MICupons/ListarTodos";
import ListarHistoricoRecebimento from "../screens/Estoque/components/MIEntradaProdutos/ListarHistoricoRecebimento";
import Fiscal from "../screens/Fiscal";
import ListarNotasFiscais from "../screens/Fiscal/components/MINotasFiscais/ListarTodas";
import MIContasReceberListarRecebimentosBaixas from "../screens/Financeiro/components/MIContasReceber/ListarRecebimentosBaixas";
import MIFluxoCaixaListarSimulacoes from "../screens/Financeiro/components/MIFluxoCaixa/ListarSimulacoes";
import { Fabrica } from "../screens/Fabrica";

const Dashboard = lazy(() => import("../screens/Dashboard"));

const Layout = () => {
  return (
    <ModalDetalheProcessoProvider>
      <ModalDetalhePedidoProvider>
        <AppBar />
        <Suspense fallback={<CircularProgress />}>
          <CssBaseline />
          <Outlet />
          <footer
            style={{
              padding: 24,
              textAlign: "center",
              backgroundColor: "#DDD",
              marginTop: 24,
            }}
          >
            <Typography variant="caption">© Techpines 2024</Typography>
          </footer>
          <div style={{ fontSize: 9, textAlign: "center", marginTop: 3 }}>
            Versão: {process.env.REACT_APP_VERSION}
          </div>
        </Suspense>

        <DialogContato />
      </ModalDetalhePedidoProvider>
    </ModalDetalheProcessoProvider>
  );
};

export default function privateRoutes(): RouteObject {
  return {
    element: <Layout />,
    children: [
      { path: "/dashboard", element: <Dashboard /> },

      { path: "/estoque", element: <Estoque /> },
      { path: "/estoque/produtos/listar-todos", element: <MIProdutosListarTodas /> },
      { path: "/estoque/relatorio-giro-estoque", element: <GiroDeEstoque /> },
      { path: "/estoque/ressuprimento/expedicao-pedidos", element: <ExpedicaoPedidos /> },
      { path: "/estoque/configuracoes", element: <ConfiguracoesEstoque /> },
      { path: "/estoque/compras/listar-solicitacoes", element: <ListarSolicitacoes /> },
      { path: "/estoque/compras/listar-ocs", element: <ListarOcs /> },
      { path: "/estoque/entrada-produtos/historico-entradas", element: <ListarHistoricoRecebimento /> },

      { path: "/financeiro", element: <Financeiro /> },
      {
        path: "/financeiro/limite-credito/lista-todas",
        element: <MIAnaliseCreditoListarTodas />,
      },
      {
        path: "/financeiro/contas-receber/listar-todas",
        element: <MIContasReceberListarTodas />,
      },
      {
        path: "/financeiro/contas-receber/listar-recibos",
        element: <MIContasReceberListarRecibos />,
      },
      {
        path: "/financeiro/contas-receber/listar-recebimentos-baixas",
        element: <MIContasReceberListarRecebimentosBaixas />,
      },
      {
        path: "/financeiro/contas-pagar/listar-todas",
        element: <MIContasPagarListarTodas />,
      },
      {
        path: "/financeiro/conta-corrente-consumo/visao-geral",
        element: <MIContaCorrenteConsumoVisaoGeral />,
      },
      {
        path: "/financeiro/configuracoes",
        element: <ConfiguracoesFinanceiro />,
      },
      {
        path: "/financeiro/integracoes-bancarias",
        element: <IntegracaoBancaria />,
      },
      {
        path: "/financeiro/caixa-bancos/extrato-contas",
        element: <MICaixaBancosExtratoContas />,
      },
      {
        path: "/financeiro/caixa-bancos/listar-lancamentos",
        element: <ListarLancamentos />,
      },
      {
        path: "/financeiro/cheques/listar-cheques",
        element: <MIChequesListarTodos />,
      },
      {
        path: "/financeiro/cheques/listar-cheques-devolvidos",
        element: <MIChequesListarTodosDevolvidos />,
      },
      {
        path: "/financeiro/fluxo-caixa/listar-simulacoes",
        element: <MIFluxoCaixaListarSimulacoes />,
      },
      {
        path: "/financeiro/cupons/listar-todos",
        element: <MICuponsListarTodos />,
      },

      { path: "/cafe", element: <Cafe /> },
      { path: "/cafe/lotes", element: <PageListaLoteCafe /> },
      { path: "/comercial", element: <Comercial /> },
      { path: "/comercial/pedidos/listar-todos", element: <MIPedidosListarTodos /> },
      { path: "/comercial/pedidos/resumo-operacoes", element: <ResumoOperacoes /> },
      { path: "/comercial/produtos/listar-todos", element: <MIProdutosListarTodos /> },
      { path: "/comercial/configuracoes", element: <ConfiguracoesComercial /> },

      { path: "/tarefas", element: <Tarefas /> },

      { path: "/cadastros", element: <Cadastros /> },
      {
        path: "/cadastros/cooperado/listar-todos",
        element: <MIPublicosListarTodos tipo_publico="A" />
      },
      {
        path: "/cadastros/cliente/listar-todos",
        element: <MIPublicosListarTodos tipo_publico="C" />
      },
      {
        path: "/cadastros/fornecedor/listar-todos",
        element: <MIPublicosListarTodos tipo_publico="F" />
      },
      {
        path: "/cadastros/empregado/listar-todos",
        element: <MIPublicosListarTodos tipo_publico="E" />
      },
      { path: "/cadastros/loja/listar-todas", element: <MILojasListarTodas /> },

      { path: "/receituario-agronomico", element: <ReceituarioAgronomico /> },

      { path: "/receituario-agronomico/agronomo/listar-todos", element: <MIAgronomoListarTodos /> },

      { path: "/receituario-agronomico/culturas/listar-todos", element: <MICulturasListarTodos /> },
      { path: "/receituario-agronomico/pragas/listar-todos", element: <MIPragasListarTodos /> },
      { path: "/receituario-agronomico/ingredientes-ativos/listar-todos", element: <MIIngredientesAtivosListarTodos /> },
      { path: "/receituario-agronomico/agrotóxicos/listar-todos", element: <MIAgrotoxicosListarTodos /> },
      { path: "/receituario-agronomico/prescricoes/listar-todos", element: <MIPrescricoesListarTodos /> },

      { path: "/configuracoes", element: <Configuracoes /> },
      { path: "/configuracoes/fluxo/:id", element: <FluxoDetalhe /> },
      { path: "/configuracoes/formularios/:id", element: <FormulariosDynDetalhe /> },

      { path: "/fiscal", element: <Fiscal /> },
      { path: "/fiscal/notas-fiscais/listar-todas", element: <ListarNotasFiscais /> },

      { path: "/fabrica", element: <Fabrica /> },

      { path: "*", element: <Navigate to="/dashboard" replace /> },
      { path: "/login", element: <Navigate to="/dashboard" replace /> },
    ],
  };
}
